import { DatePicker as AntDatePicker } from "antd";
import dayjs, { Dayjs } from "dayjs";
import styles from "./style.module.scss";

const { RangePicker } = AntDatePicker;

const SHARED_PROPS = {
  format: "YYYY-MM-DD HH:mm:ss",
  getPopupContainer: (trigger: HTMLElement) =>
    trigger.parentElement || document.body,
};

// Discriminated Union Props
type SingleProps = {
  type: "single";
  value?: Dayjs | null;
  onChange: (val: Dayjs | null) => void;
  placeholder?: string;
};

type RangeProps = {
  type: "range";
  value?: [Dayjs, Dayjs] | null;
  onChange: (val: [Dayjs, Dayjs] | null) => void;
  placeholder?: [string, string];
};

type DatePickerProps = SingleProps | RangeProps;

function DatePickerBase(props: DatePickerProps) {
  if (props.type === "single") {
    return (
      <AntDatePicker
        {...SHARED_PROPS}
        showTime={{
          format: "HH:mm:ss",
          defaultValue: dayjs("00:00:00", "HH:mm:ss"),
        }}
        value={props.value}
        onChange={(d) => props.onChange(d)}
        placeholder={props.placeholder}
        className={styles.datePicker}
      />
    );
  }

  return (
    <RangePicker
      {...SHARED_PROPS}
      showTime={{
        format: "HH:mm:ss",
        defaultValue: [
          dayjs("00:00:00", "HH:mm:ss"),
          dayjs("00:00:00", "HH:mm:ss"),
        ],
      }}
      value={props.value}
      onChange={(d) =>
        d?.[0] && d?.[1] ? props.onChange([d[0], d[1]]) : props.onChange(null)
      }
      placeholder={props.placeholder}
      className={styles.rangePicker}
    />
  );
}

// Exports
export const DateTime = (props: Omit<SingleProps, "type">) => (
  <DatePickerBase
    {...props}
    type="single"
    placeholder={props.placeholder || "Select Date & Time"}
  />
);

export const DateTimeRange = (props: Omit<RangeProps, "type">) => (
  <DatePickerBase
    {...props}
    type="range"
    placeholder={props.placeholder || ["Start Date & Time", "End Date & Time"]}
  />
);
